import Documents from "components/Documents/drawer/DocumentsDrawer";
import "./ConsultingPageContainer.scss";

type MSAContainerPropTypes = {
  header?: React.ReactNode;
  children?: React.ReactNode;
  childrenLeft?: React.ReactNode;
  childrenRight?: React.ReactNode;
  layout?: "full" | "split" | "custom";
  fileId?: string;
  serviceId?: string;
  serviceType?: string;
};

const ConsultingPageContainer = ({
  header,
  children,
  childrenRight,
  childrenLeft,
  layout = "full",
  fileId,
  serviceId,
  serviceType,
}: MSAContainerPropTypes) => {
  // If we have direct children, render them directly
  if (layout === "custom" || (children && !childrenLeft && !childrenRight)) {
    return (
      <div className="ConsultingPageContainer swim-wrapper h-100">
        {header && (
          <div className="ConsultingPageContainer__Header">{header}</div>
        )}
        {children}
      </div>
    );
  }

  // Otherwise use the traditional split layout
  return (
    <>
      {children}
      <div className="ConsultingPageContainer swim-wrapper h-100">
        {header && (
          <div className="ConsultingPageContainer__Header">{header}</div>
        )}
        <div
          className={`grid-layout gl-2 no-gap-tb swimlanes msa-medical-${layout} w-100`}
        >
          <div className="swim-headers">Consulting</div>
          <div className="swim-headers">Notes + Documents</div>
          <div className="swim-column">{childrenLeft}</div>
          <div className="swim-column">{childrenRight}</div>
        </div>
        <Documents
          fileId={Number(fileId)}
          serviceId={Number(serviceId)}
          serviceType={serviceType}
        />
      </div>
    </>
  );
};

export default ConsultingPageContainer;
